<template>
  <div class="panel panel-body">
    <general-stepper
      :steps-info="stepsInfo"
      :enable-save-button="enableSaveButton"
      @finish="saveSubscribableGrouping"
      @changeStep="changeStep"
    >
      <!--contents step-->
      <template
        slot="content-step-1"
        class="col-xs-12"
      >
        <beware-edit v-if="isStored" />

        <select-component
          v-model="selectComponentValues"
          :is-stored="isStored"
          :program-id="programId"
          @canFinishStep="finishStep(1)"
          @canNotFinishStep="notFinishStep(1)"
          @emptySubscribableNames="selectComponentValues.subscribableNames = []"
        />
      </template>

      <template
        slot="content-step-2"
        class="col-xs-12"
      >
        <beware-edit v-if="isStored" />

        <check-component
          v-model="checkComponentValues"
          @canFinishStep="finishStep(2)"
          @canNotFinishStep="notFinishStep(2)"
        />
      </template>

      <template
        slot="content-step-3"
        class="col-xs-12"
      >
        <beware-edit v-if="isStored" />

        <grouping-rules
          v-model="rulesComponentValues"
          :categories="availableCategories"
          :characteristic-required-categories="characteristicRequiredCategories"
          :errors="errors"
          :program-id="programId"
          @canFinishStep="finishStep(3)"
          @canNotFinishStep="notFinishStep(3)"
        />
      </template>
    </general-stepper>

    <modal
      :open="openModal"
      :title="trans('subscription.subscribable_groupings.confirmation_title')"
      style="text-align:left;"
      @close="openModal = false"
    >
      <template v-if="students">
        <p style="color:red">
          {{ trans('subscription.subscribable_groupings.confirmation') }}
        </p>

        <ul>
          <li
            v-for="student in students"
          >
            <a
              href="#"
              @click="openStudentLink(student.id)"
            >
              {{ student.name }}
            </a>
          </li>
        </ul>
      </template>

      <template v-else>
        <p style="color:red">
          {{ trans('subscription.subscribable_groupings.beware_edit') }}
        </p>
      </template>
      <button
        type="button"
        class="btn btn-default pull-right"
        @click="closeModal()"
      >
        {{ trans('core.cancel') }}
      </button>

      <button
        type="button"
        class="btn btn-success pull-right"
        :disabled="!enableSaveButton"
        @click="saveSubscribableGrouping(true)"
      >
        {{ trans('core.save') }}
      </button>

      <br style="clear:both">
    </modal>
  </div>
</template>

<script>
import toast from '@/services/toast'
import Modal from '@/employees/AttendanceList/components/Modal'
import CheckComponent from '@/employees/components/SubscribableGrouping/CheckComponent'
import SelectComponent from '@/employees/components/SubscribableGrouping/SelectComponent'
import GroupingRules from '@/employees/components/SubscribableGrouping/GroupingRules'
import BewareEdit from '@/employees/components/SubscribableGrouping/BewareEdit'
import { SINGLE } from '@/constants'

export default {
  name: 'SubscribableGroupingSteps',

  components: { Modal, BewareEdit, CheckComponent, GroupingRules, SelectComponent },

  props: {
    programId: {
      required: true,
      type: String,
    },
    startdateInitial: {
      required: true,
      type: String,
    },
    enddateInitial: {
      required: true,
      type: String,
    },
    availableCategories: {
      required: true,
      type: Array,
    },
    characteristicRequiredCategories: {
      required: true,
      type: Array,
    },
    editData: {
      required: false,
      type: String,
      default: null,
    },
  },

  data () {
    return {
      isStored: false,

      selectComponentValues: {
        subscribablesType: SINGLE,
        startdate: this.startdateInitial,
        enddate: this.enddateInitial,
        subscribableNames: [],
        hasSubscribables: 'subscribables',
      },

      checkComponentValues: {
        subscribableNames: [],
        startdate: this.startdateInitial,
        enddate: this.enddateInitial,
        selectedSubscribableIds: [],
        programId: this.programId,
        subscribablesType: SINGLE,
        hasSubscribables: 'subscribables',
      },

      rulesComponentValues: {
        name: null,
        description: null,
        number: 1,
        selectedSubscribableIds: [],
        category: 'rubric',
        validationRules: null,
        studentCharacteristic: null,
        sendNotification: false,
        showSidebarDates: false,
        visibleFrom: null,
        visibleTill: null,
      },

      enableSaveButton: false,
      errors: {},

      openModal: false,
      students: null,
    }
  },

  computed: {
    stepsInfo () {
      return this.$store.state.steps.steps_info
    },
  },

  watch: {
    selectComponentValues (newValue) {
      this.checkComponentValues.subscribableNames = newValue.subscribableNames
      this.checkComponentValues.startdate = newValue.startdate
      this.checkComponentValues.enddate = newValue.enddate
      this.checkComponentValues.subscribablesType = newValue.subscribablesType
      this.checkComponentValues.hasSubscribables = newValue.subscribableNames.length > 0 ? 'subscribables' : 'empty'
    },

    checkComponentValues (newvalue) {
      this.rulesComponentValues.selectedSubscribableIds = newvalue.selectedSubscribableIds
    },
  },

  created () {
    this.$store.dispatch('add_steps_info', {
      1: {
        step: 1,
        title: Lang.get('subscription.subscribable_groupings.step_select_components'),
        finished: false,
      },
      2: {
        step: 2,
        title: Lang.get('subscription.subscribable_groupings.step_check_components'),
        finished: false,
      },
      3: {
        step: 3,
        title: Lang.get('subscription.subscribable_groupings.step_rules'),
        finished: false,
      },
    },
    ).then(() => {
      this.$store.dispatch('set_active_step', { step: 1 })

      if (this.editData != null) {
        this.isStored = true

        const editData = JSON.parse(this.editData)

        this.selectComponentValues = {
          subscribablesType: editData.subscribablesType,
          startdate: this.startdateInitial,
          enddate: this.enddateInitial,
          subscribableNames: editData.subscribableNames,
          hasSubscribables: editData.subscribableNames.length > 0 ? 'subscribables' : 'empty',
        }

        this.checkComponentValues = {
          subscribableNames: editData.subscribableNames,
          startdate: this.startdateInitial,
          enddate: this.enddateInitial,
          selectedSubscribableIds: editData.selectedSubscribableIds,
          programId: this.programId,
          subscribablesType: editData.subscribablesType,
          hasSubscribables: editData.subscribableNames.length > 0 ? 'subscribables' : 'empty',
        }

        this.rulesComponentValues = {
          name: editData.name,
          description: editData.description,
          number: editData.number,
          selectedSubscribableIds: editData.selectedSubscribableIds,
          category: editData.category,
          validationRules: editData.validationRules != null ? JSON.stringify(editData.validationRules) : null,
          studentCharacteristic: [editData.studentCharacteristic],
          sendNotification: false,
          showSidebarDates: editData.visibleFrom !== null || editData.visibleTill !== null,
          visibleFrom: editData.visibleFrom ? moment(editData.visibleFrom.date).format('YYYY-MM-DD') : null,
          visibleTill: editData.visibleTill ? moment(editData.visibleTill.date).format('YYYY-MM-DD') : null,
        }

        this.finishStep(1)
        this.finishStep(2)
        this.finishStep(3)
      }
    })
  },

  methods: {
    changeStep (event) {
      this.$store.dispatch('set_active_step', { step: event.step })
    },

    finishStep (stepNumber) {
      return this.$store.dispatch('update_step_finished', { step: stepNumber, finished: true })
    },

    notFinishStep (stepNumber) {
      return this.$store.dispatch('update_step_finished', { step: stepNumber, finished: false })
    },

    saveSubscribableGrouping (confirmed = false) {
      // disable the save button while creating/updating
      this.enableSaveButton = false

      this.errors = {}
      this.students = null

      const params = {
        program_id: this.programId,
        subscribable_ids: this.checkComponentValues.selectedSubscribableIds,
        name: this.rulesComponentValues.name,
        description: this.rulesComponentValues.description,
        number: this.rulesComponentValues.number,
        subscribables_type: this.selectComponentValues.subscribablesType,
        logic_category: this.rulesComponentValues.category,
        student_characteristic: this.rulesComponentValues.studentCharacteristic,
        validation_rules: this.rulesComponentValues.validationRules,
        send_notification: this.rulesComponentValues.sendNotification,
        show_sidebar_dates: this.rulesComponentValues.showSidebarDates,
        visible_from: this.rulesComponentValues.visibleFrom,
        visible_till: this.rulesComponentValues.visibleTill,
      }

      if (confirmed) {
        params.confirm = true
      }

      if (this.isStored) {
        axios.put(`/employee/subscribable-groupings/${JSON.parse(this.editData).id}`, params, { errorHandle: false }).then((response) => {
          window.location.href = response.data.redirect
        }).catch((error) => {
          this.errors = error.response.data.data

          if (Object.keys(this.errors).length === 1 && (this.errors.hasOwnProperty('students') || this.errors.hasOwnProperty('revalidate_students'))) {
            if (this.errors.hasOwnProperty('students')) {
              this.students = JSON.parse(this.errors.students)
            }

            this.openModal = true
          }

          this.enableSaveButton = true
        })
      } else {
        axios.post('/employee/subscribable-groupings', params, { errorHandle: false }).then((response) => {
          window.location.href = response.data.redirect
        }).catch((error) => {
          this.errors = error.response.data.data

          this.enableSaveButton = true
        })
      }
    },

    openStudentLink (id) {
      window.open(`/employee/students/${id}`, '_blank')
    },

    closeModal () {
      this.openModal = false
      this.enableSaveButton = true
    },
  },
}
</script>

<style>
    .v-stepper {
        margin-bottom: 15px;
    }
</style>
